import { render, staticRenderFns } from "./ApplicantDocumentsControl.vue?vue&type=template&id=5df81b30&"
import script from "./ApplicantDocumentsControl.vue?vue&type=script&lang=js&"
export * from "./ApplicantDocumentsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports